export default {
  businessDevelopmentFilterLabel: 'Buisness Development',
  communicationsFilterLabel: 'Communications',
  marketingFilterLabel: 'Marketing',
  export: 'Export',
};
